import React from "react";

// Utils
import moment from "moment-timezone";

// Components
import MaterialTable from "material-table";
import Tooltip from "@material-ui/core/Tooltip";
import RatesSummary, { NEEDS_PRICE_COLOR } from "./RatesSummary";

// Icons
import tableIcons from "../../Table/TableIcons";

const currencyFormat = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

// The price most nights share, so nights priced differently (holidays, manual
// overrides) can be pointed out. Null when there's no single most common price.
const getUsualPrice = (rates) => {
  const counts = new Map();
  rates.forEach((rate) => {
    const price = Number(rate.price);
    counts.set(price, (counts.get(price) || 0) + 1);
  });

  const [first, second] = [...counts.entries()].sort((a, b) => b[1] - a[1]);
  if (!first || first[1] < 2 || (second && second[1] === first[1])) return null;

  return first[0];
};

const RatesTableComponent = ({ ratesArray, isLoading, roomQty = 1 }) => {
  // Need to spread array so it doesn't fail
  const formattedData = ratesArray.map((o) => ({ ...o }));
  const usualPrice = getUsualPrice(formattedData);

  return (
    <>
      <MaterialTable
        title="Rates by Date"
        isLoading={isLoading}
        icons={tableIcons}
        columns={[
          {
            title: "Date",
            field: "date",
            render: (rowData) => (
              <>{moment(rowData.date).tz("America/Chicago").format("ll")}</>
            ),
          },
          {
            title: "Price",
            field: "price",
            type: "currency",
            headerStyle: {
              textAlign: "right",
            },
            render: (rowData) => {
              const price = Number(rowData.price);
              const formatted = currencyFormat.format(price || 0);

              if (usualPrice === null || price === usualPrice) return formatted;

              return (
                <Tooltip
                  title={`Differs from the usual ${currencyFormat.format(
                    usualPrice
                  )} rate`}
                >
                  <span style={{ color: NEEDS_PRICE_COLOR, fontWeight: 600 }}>
                    {formatted}
                  </span>
                </Tooltip>
              );
            },
          },
          {
            title: "Tax",
            field: "tax",
            type: "numeric",
            headerStyle: {
              textAlign: "right",
            },
            render: (rowData) => <>{rowData.tax}%</>,
          },
        ]}
        data={formattedData}
        options={{
          search: false,
          paging: false,
          maxBodyHeight: 480,
        }}
      />
      <RatesSummary ratesData={formattedData} roomQty={roomQty} />
    </>
  );
};

export default RatesTableComponent;
